// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"e65d95c5","513":"6fd06771","703":"6c325c4f","787":"30be8452"}[chunkId] + ".chunk.js";
};